import { createGlobalStyle } from 'styled-components';

export const RootCss = createGlobalStyle`
  :root {
    font-family:"Yu Gothic", "游ゴシック", YuGothic, "游ゴシック体", "Hiragino Sans", "Hiragino Kaku Gothic ProN", 'Noto Sans JP', sans-serif;
    font-weight: 500;
  }
  a {
    color: inherit;
    text-decoration: none;
  }
  .grecaptcha-badge {
    visibility: hidden;
  }
`